import { ref } from 'vue'
import { createInjectionState } from '@vueuse/shared'

const [useProvideTrainerPersonsStore, useTrainerPersonsStore] =
  createInjectionState(initialData => {
    const items = ref(initialData)

    return {
      items
    }
  })

export { useProvideTrainerPersonsStore, useTrainerPersonsStore }
